import { CognitoUserPool } from 'amazon-cognito-identity-js';
import awsConfig from '../aws-exports';

const poolData = {
  UserPoolId: awsConfig.userPoolId,
  ClientId: awsConfig.userPoolWebClientId,
};

const userPool = new CognitoUserPool(poolData);

export default userPool;
